import { render, staticRenderFns } from "./takingsFilterBox.vue?vue&type=template&id=1c28a519&"
import script from "./takingsFilterBox.vue?vue&type=script&lang=ts&"
export * from "./takingsFilterBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports